// extracted by mini-css-extract-plugin
export default {"wrap":"HelpIcon_wrap__Zj+bO"};